import React from 'react';
import { FictionalIcon } from '../../customFrontend/parts';
import { ChatappTopic } from '../../siteBrands/chatapp/types';

/**
 * The topic pages' copy (manifest `type` `topic`), standard German with
 * informal "du". Written for chatapp.net, not translated from another site.
 */
export const TOPICS: Record<string, ChatappTopic> = {
  '/reife-frauen': {
    path: '/reife-frauen',
    slug: 'mature',
    name: 'Reife Frauen',
    kicker: 'Flirten mit Erfahrung, ab 40',
    h1: 'Sexchat mit reifen Frauen',
    lead: 'Kostenlos anmelden ohne Kreditkarte, deine ersten Nachrichten gratis und eine Suche, die bei 40 Jahren beginnt.',
    intro: (
      <p>
        Ein Flirt wird oft erst richtig spannend, wenn er ein bisschen Erfahrung mitbringt. Bei Chatapp kannst du
        deshalb gezielt mit reifen Frauen chatten: mit Profilen von Frauen in den Vierzigern, Fünfzigern und darüber,
        die wissen, was ihnen gefällt, und das auch sagen. Ob du es MILF Chat nennst oder einfach Chat mit älteren
        Frauen, los geht es wie überall bei Chatapp, mit einem kostenlosen Profil und Gratis-Nachrichten zum Start.
      </p>
    ),
    sections: [
      {
        title: 'Was den Reiz reifer Frauen ausmacht',
        body: (
          <>
            <p>
              Selbstbewusstsein verändert ein Gespräch. Ein Profil mit ein paar Jahren mehr Lebenserfahrung spielt
              weniger Spielchen, stellt lieber eine klare Frage und lässt dich merken, wenn deine Antwort gesessen
              hat. Genau das schätzen viele am Sexchat mit reifen Frauen: Die Neckereien sind schlagfertiger, ein
              Kompliment muss man sich verdienen, und niemand hat es eilig.
            </p>
            <p>
              Das gefällt ganz unterschiedlichen Männern. Jüngere mögen oft Frauen, die genau wissen, was sie
              wollen, und das nicht verstecken. Männer im gleichen Alter mögen es, wenn im Chat dieselbe Musik,
              dieselben Serien und dieselben Erinnerungen an die Neunziger zur Sprache kommen. Willkommen ist jeder
              ab 18.
            </p>
          </>
        ),
      },
      {
        title: 'MILF Chat, reife Frauen oder ältere Frauen?',
        body: (
          <>
            <p>
              Wer nach einem Chat mit älteren Frauen sucht, stößt auf verschiedene Begriffe. MILF ist der
              direkteste, reife Frauen klingt etwas eleganter, und ältere Frauen sagt einfach, worum es geht. Bei
              Chatapp führen alle drei an denselben Ort: zu Profilen von Frauen ab 40, die zum Flirten da sind,
              und zu einem Gespräch in deinem Tempo.
            </p>
            <p>
              Meldest du dich über diese Seite an, steht deine Suche gleich auf 40 Jahre und älter. So passen die
              ersten Profile, die du siehst, zu dem, was du suchst. Den Altersregler kannst du später jederzeit
              selbst verschieben, weiter oder enger.
            </p>
          </>
        ),
      },
      {
        title: 'So funktioniert der Chat mit reifen Frauen',
        body: (
          <>
            <p>
              Die Anmeldung dauert etwa eine Minute: Nickname wählen, angeben, mit wem du chatten möchtest, und
              E-Mail-Adresse eintragen. Nach einer Kreditkarte fragen wir dabei nie. Deine ersten Nachrichten sind
              gratis, ob du sie nach Feierabend in Hannover schreibst oder im ICE zwischen Nürnberg und Berlin. So
              kannst du in Ruhe ein paar Flirts verschicken und herausfinden, ob dir diese Art Chat gefällt.
            </p>
            <p>
              Sind die Gratis-Nachrichten aufgebraucht, kosten Nachrichten, Flirts und Fotos Credits. Ein Paket
              kaufst du nur, wenn du weiterschreiben willst, und auf der Preisseite siehst du vorher, was alles
              kostet. Chatapp ist ein Unterhaltungsangebot: Profile mit Personensymbol sind fiktiv, und der Spaß
              liegt im Gespräch selbst.
            </p>
          </>
        ),
      },
    ],
    faqTitle: 'Fragen zum Chat mit reifen Frauen',
    faq: [
      {
        q: 'Was kostet der Chat mit reifen Frauen?',
        a: <p>Die Anmeldung ist kostenlos und ohne Kreditkarte, und deine ersten Nachrichten kosten nichts. Danach bezahlst du Nachrichten, Flirts und Fotos mit Credits. Jeden Preis siehst du, bevor du ein Paket kaufst.</p>,
      },
      {
        q: 'Kann ich die Altersgrenze später ändern?',
        a: <p>Ja. Über diese Seite beginnt deine Suche bei 40 Jahren, aber den Altersregler stellst du jederzeit selbst um, nach oben wie nach unten.</p>,
      },
      {
        q: 'Sind die Profile reifer Frauen echt?',
        a: (
          <p>
            Nein. Chatapp nutzt fiktive Profile, deren Ziel es ist, mit Nutzern zu flirten. Du erkennst sie am
            Personensymbol <FictionalIcon language="de" /> in ihrem Profil, und physischer Kontakt mit diesen
            Profilen ist nicht möglich. Der Chat mit reifen Frauen ist hier Unterhaltung, keine Möglichkeit, Treffen
            zu verabreden.
          </p>
        ),
      },
      {
        q: 'Bleibt mein Chat diskret?',
        a: <p>Ja. Andere Mitglieder sehen nur deinen Nickname, nie deinen Namen oder deine E-Mail-Adresse. In deinen sozialen Netzwerken erscheint nichts, und welche E-Mails du bekommst, entscheidest du selbst.</p>,
      },
    ],
    cta: {
      title: 'Lust auf einen Flirt mit mehr Erfahrung?',
      text: 'Leg kostenlos ein Profil an, schick deine ersten Nachrichten gratis und starte mit Profilen ab 40.',
      button: 'Gratis mitchatten',
    },
    citiesTitle: 'Sexchat in deutschen Städten',
    link: {
      title: 'Lieber mit reifen Frauen flirten?',
      text: 'Sexchat und MILF Chat mit Profilen von Frauen ab 40.',
      anchor: 'Sexchat mit reifen Frauen',
    },
  },
};
